import Param from '../lib/param.es6';
import SoundController from '../controllers/soundController.es6';
import ConfirmController from '../controllers/confirmController.es6';
import ParentModalController from '../controllers/parentModalController.es6';
import TopController from '../controllers/topController.es6';
import Modal from '../views/components/modal.es6';
import Viwport from '../views/components/viewport.es6';

export default class Main {
    constructor() {
        this.main = document.querySelector('.js-main');
    }

    init() {
        this.confirmController = new ConfirmController();
        this.parentModalController = new ParentModalController();
        this.topController = new TopController();
        this.modal = new Modal();
        this.viewport = new Viwport();
        this.isInited = false;

        window.COMMON.sound.progressCheck();
        document.addEventListener('endLoading', () => {
            setTimeout(() => {
                this.main.classList.remove('-loading');
            }, 500);
        });

        this.confirmController.confirmAndStartPage();

        document.addEventListener('confirmAndStartPage', () => {

            if(!this.isInited){
                window.COMMON.sound.sound.playAudio('bgm');
                window.COMMON.sound.sound.playAudio('top');
            }
            
            this.topController.startTopAnimation();
            this.isInited = true;
        });

        this.parentModalController.openParentModal();
        document.addEventListener('openParentModal', () => {
            window.COMMON.sound.sound.stopAudio('top');
            window.COMMON.sound.sound.playAudio('parent-modal');
        });

        this.parentModalController.closeParentModal();
        document.addEventListener('closeParentModal', () => {
            window.COMMON.sound.sound.stopAudio('parent-modal');
            window.COMMON.sound.sound.playAudio('se');
        });
    }
}

const main = () => {
    const param = new Param();
    const sound = new SoundController();

    window.COMMON = {
        param: param,
        sound: sound,
    };
    const router = new Main();

    window.addEventListener('load', function () {
        router.init();
    });
};

// 実行
main();
